import { useQuery } from "@tanstack/react-query";
import { processamentoIAService } from "@/services/api/processamento-ia.service";
import { processamentoIaKeys } from "@/services/api/queries/processamento-ia.queries";

export function useProcessamentoIAKpis() {
  const { data, isLoading, refetch, isRefetching } = useQuery({
    queryKey: processamentoIaKeys.resumo,
    queryFn: () => processamentoIAService.resumo(),

    refetchInterval: 30000,
  });

  return {
    resumo: data || { total: 0, pendente: 0, sucesso: 0, falha: 0 },
    isLoading: isLoading || isRefetching,
    refetch,
  };
}
